export default defineNuxtRouteMiddleware(async (to) => {
    // Get locale from cookie
    const locale = getCookie('i18n_redirected') ?? 'en'
    // List of locales
    const locales = ["en", "sv", "fr", "ch", "da", "nl", "no", "de", "dk"];
     // Removes empty parts like '' from '//'
    const pathSegments = to.path.split("/").filter(Boolean);
    // Remove locales from path and retrieve only paths part of the routes
    const pathWithoutLocales = pathSegments.filter((segment) => !locales.includes(segment));

    // If second path segment is a locale for example in cases when we append /de/de/ or /de/sv/ | sv/fr/ etc...
    // Update the route to only one locale segment -> /de/path
    // Or when first path segment is not equal to the current locale
    if (locales.includes(pathSegments[1]) || (locales.includes(pathSegments[0] && pathSegments[0] != locale))) {
        return navigateTo(`/${locale}/${pathWithoutLocales.join('/')}`, { replace: true });
    }
})